import React from 'react'

const Instagram: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 20 20"><g><path d="M15 0H5C2.2 0 0 2.2 0 5v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5zm3 15c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h10c1.7 0 3 1.3 3 3z" fill="#ffffff" opacity="1" data-original="#000000"></path><path d="M10 5c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" fill="#ffffff" opacity="1" data-original="#000000"></path><circle cx="15" cy="5" r="1" fill="#ffffff" opacity="1" data-original="#000000"></circle></g></svg>
  )
}

export default Instagram